const identify = ({ eventName, ...payload }) => {
  if (window.analytics) {
    window.analytics.identify(payload);
  }
};

export default identify;
